import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import '@fontsource/quicksand/latin-500.css'
import '@fontsource/quicksand/latin-700.css'
import './index.css'
import AppRoutes from './AppRoutes.jsx'
import { isPrerendered } from './prerendered.js'

const container = document.getElementById('root')
const tree = (
  <StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>
)

// The prerendered markup is the home page; other paths render fresh on the client
if (isPrerendered && window.location.pathname === '/') {
  hydrateRoot(container, tree)
} else {
  container.textContent = ''
  createRoot(container).render(tree)
}
